<template>
  <div class="reject-order">
    <re-dialog :visible.sync="show" title="驳回原因" width="500px" :appendToBody="true">
      <div class="p30">
        <el-form label-width="100px" :model="form" :rules="rules" ref="addCompany" style="width: 100%;">
          <el-form-item label="驳回原因：" prop="platform_sale_check_remarks">
            <el-input v-model="form.platform_sale_check_remarks" size="small" type="textarea" :rows="6"
                      resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="fr ac jc">
        <el-button type="primary" @click="confirm" size="small">确认</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
export default {
  name: "rejectOrder",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    order_id: {
      type: [String, Number],
      default: ''
    },
    currentMessage: {
      type: String,
      default: ''
    },
  },
  watch: {
    value(n) {
      if (n) {
        this.show = true;
      }
    },
    currentMessage(n) {
      this.form.platform_sale_check_remarks = n;
    },
    show(n) {
      if (!n) {
        this.$emit('input', false);
      }
    }
  },
  created() {
  },
  data() {
    return {
      show: this.$props.value,
      form: {
        platform_sale_check_remarks: this.$props.currentMessage,
      },
      rules: {
        platform_sale_check_remarks: [
          {required: true, message: '请输入驳回原因！', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    confirm() {
      let is_submit = false;
      this.$refs.addCompany.validate((valid) => {
        if (!valid) {
          is_submit = true;
          return;
        }
      });
      if (is_submit) return;
      this.post("orderInterfaces/v1.0/rejectOrder", {
        ...this.form,
        order_id: this.$props.order_id
      }).then(res => {
        this.$message.success("已驳回！");
        this.$emit("success");
        this.show = false;
      })
    }
  }
}
</script>

<style lang="scss">
.reject-order {

  .dialog {
    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__footer {
      width: 100%;
      padding: 10px 0;
      border-top: 1px solid #e5e5e5;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/rejectOrder.vue